<template>
    <div class="sub-page">
        <!-- 커스텀 Title -->
        <p class="le-heading5 text-center pt-10">
            커스텀 템플릿 (test-custom)
        </p>
  
        <!-- 이미지/링크는 그대로 쓰고 싶으면 그대로 사용 가능 -->
        <section class="c-section d-flex justify-center pt-0">
            <div class="c-contanier text-center">
                <div class="mt-6 d-flex justify-center">
                    <div>
                        <a
                            v-if="detailLinkUrl"
                            :href="detailLinkUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="d-flex"
                        >
                            <v-img
                                :src="imageUrl"
                                :width="$vuetify.breakpoint.mdAndUp ? 220 : ($vuetify.breakpoint.smOnly ? 220 : 160)"
                            />
                        </a>
  
                        <v-img
                            v-else
                            :src="imageUrl"
                            :width="$vuetify.breakpoint.mdAndUp ? 220 : ($vuetify.breakpoint.smOnly ? 220 : 160)"
                        />
                    </div>
                </div>
  
                <p class="le-text-subtitle2 mt-6">
                    이 화면은 “커스텀 템플릿 추가” 테스트용입니다.
                </p>
  
                <p class="le-text-body2 mt-3">
                    slug: <strong>{{ slug }}</strong>
                </p>
  
                <!-- 폼 (로직은 mixin의 name/email/showConfirm/submit 그대로 사용) -->
                <div class="mt-10">
                    <v-form ref="form">
                        <div class="d-flex flex-column align-center">
                            <div
                                style="width: 320px;"
                                class="mb-4 text-left"
                            >
                                <p class="contact_title mb-2">
                                    <strong>이름</strong>
                                    <span class="text-red1 ml-1">*</span>
                                </p>
                                <v-text-field
                                    v-model="name"
                                    :rules="[v => !!v || $t('trialBadgeCampaign.errors.nameRequired')]"
                                    outlined
                                    dense
                                />
                            </div>
  
                            <div
                                style="width: 320px;"
                                class="mb-2 text-left"
                            >
                                <p class="contact_title mb-2">
                                    <strong>이메일</strong>
                                    <span class="text-red1 ml-1">*</span>
                                </p>
                                <v-text-field
                                    v-model="email"
                                    :rules="[
                                        v => !!v || $t('trialBadgeCampaign.errors.emailRequired'),
                                        v => /.+@.+\..+/.test(v) || $t('trialBadgeCampaign.errors.emailInvalid')
                                    ]"
                                    outlined
                                    dense
                                />
                            </div>
  
                            <v-btn
                                class="mt-6"
                                color="orange1"
                                depressed
                                dark
                                @click="showConfirm"
                            >
                                발행하기
                            </v-btn>
                        </div>
                    </v-form>
                </div>
            </div>
        </section>
  
        <!-- Confirm Dialog (DefaultCampaign과 동일 로직/상태 사용) -->
        <v-dialog
            v-model="confirmOpen"
            width="500"
        >
            <v-card class="pa-0 rounded-lg">
                <div class="le-heading6 pa-5">
                    {{ $t('trialBadgeCampaign.dialogConfirm.title') }}
                </div>
  
                <div
                    v-if="loading"
                    class="center-absolute"
                >
                    <v-progress-circular
                        indeterminate
                        color="orange1"
                        size="60"
                        width="10"
                    />
                </div>
  
                <div
                    class="le-text-body2 pl-5 pr-6"
                    style="min-height:88px;"
                >
                    <p class="mb-3">
                        {{ $t('trialBadgeCampaign.dialogConfirm.intro') }}
                    </p>
                    <strong>{{ name }}</strong><br />
                    <strong>{{ email }}</strong><br />
                    <p class="mt-3">
                        {{ $t('trialBadgeCampaign.dialogConfirm.question') }}
                    </p>
                </div>
  
                <div class="pa-5 d-flex justify-end gap-3">
                    <v-btn
                        color="blue1"
                        outlined
                        depressed
                        class="text-white1"
                        @click="confirmOpen=false"
                    >
                        {{ $t('trialBadgeCampaign.dialogConfirm.btnNo') }}
                    </v-btn>
                    <v-btn
                        color="orange1"
                        depressed
                        class="text-white1"
                        :class="{disabled:loading}"
                        @click="submit"
                    >
                        {{ $t('trialBadgeCampaign.dialogConfirm.btnYes') }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
  
        <!-- Done Dialog -->
        <v-dialog
            v-model="doneOpen"
            width="500"
        >
            <v-card class="pa-0 rounded-lg">
                <div class="le-heading6 pa-5">
                    {{ $t('trialBadgeCampaign.dialogDone.title') }}
                </div>
                <div
                    class="le-text-body2 pl-5 pr-6"
                    style="min-height:88px;"
                    v-html="$t('trialBadgeCampaign.dialogDone.body')"
                ></div>
                <div class="pa-5 d-flex justify-end gap-3">
                    <v-btn
                        color="orange1"
                        depressed
                        class="text-white1"
                        @click="doneOpen=false"
                    >
                        {{ $t('trialBadgeCampaign.dialogDone.btnOk') }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import campaignIssueMixin from '@/views/campaigns/_shared/campaignIssueMixin';
  
export default {
    name: 'CustomCampaignTest',
    mixins: [campaignIssueMixin],
};
</script>
  